import React, { useEffect, useState } from "react";
import qt from "@qt-base/jssdk";
import wxShare from "@qt-wx/share";
import "@qt-web/rem-standard";
import "@qt-web/css-common";
import { Provider } from "@qt-builder/material-context";
import { useState as useState__8, useEffect as useEffect__8 } from "react";
import axios from "axios";
import Toast from "@qt-react/toast";
import "@qt-react/toast/dist/index.css";
window.__BUILDER_PROJECT_ID = '5fb26b6541195f2c744252ba';
window.__BUILDER_ENV = 'prd';
window.__BUILDER_PAGE_ID = '5fb26b6541195f08384252bb';
const isInApp = qt.env.inApp;

const formatTime = time => {
  const newTime = new Date(time.replace(/-/g, '/'));
  return newTime;
};

const isExpire = endTime => {
  const currentTime = new Date();

  if (endTime) {
    const newEndTime = formatTime(endTime);

    if (currentTime > newEndTime) {
      return true;
    }
  }

  return false;
};

const isNotStart = startTime => {
  const currentTime = new Date();

  if (startTime) {
    const newStartTime = formatTime(startTime);

    if (currentTime < newStartTime) {
      return true;
    }
  }

  return false;
};

const getDisplayBlock = (startTime, endTime) => {
  let display = "block";

  if (endTime && isExpire(endTime) || startTime && isNotStart(startTime)) {
    display = 'none';
  }

  return display;
};

const getShareLink = () => {
  const url = window.location.href;
  return url;
};

const getHeight = () => {
  const winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  return winHeight;
};

const ContainerRender = ({
  basicConfig: basicConfig,
  containerConfig: containerConfig,
  children: children,
  id = "",
  nodeId = "",
  nodeType = ""
}) => {
  const shareConfig = {
    title: basicConfig.shareTitle,
    desc: basicConfig.shareSubTitle,
    imageUrl: basicConfig.shareImg,
    link: basicConfig.shareLink || getShareLink()
  };
  const wxShareConfig = {
    title: basicConfig.shareTitle,
    desc: basicConfig.shareSubTitle,
    imgUrl: basicConfig.shareImg,
    link: basicConfig.shareLink || getShareLink()
  }; //微信分享

  if (wxShare.isInWeixin) {
    wxShare.setShareConfig(wxShareConfig);
  }

  if (isInApp) {
    window.onPageAppear = async () => {
      await qt.page.setNavbar({
        show: true
      });
    };

    qt.page.setNavbar({
      hideShare: basicConfig.isHiddenAppShare
    });
    qt.page.setShare(shareConfig);
  }

  let inIosApp = qt.env.inIosApp;

  if (inIosApp) {
    window.addEventListener('hashchange', function () {
      qt.page.setShare(shareConfig);
    });
  }

  useEffect(() => {
    qt.monitor.bmsPageViewEntry({
      eventId: 'componentContainer_view',
      nodeId,
      nodeType
    });
    document.title = basicConfig.title;
    document.body.style.fontSize = '16px';
    document.body.style.background = containerConfig.bgc;
    document.body.style.backgroundImage = containerConfig.bgimg;
    document.body.style.backgroundRepeat = 'repeat';
    document.getElementById('root').minHeight = window.innerHeight;

    if (inIosApp) {
      return window.removeEventListener('hashchange', () => {});
    }
  }, []);
  const {
    startTime,
    endTime,
    endTitle,
    beforeTitle,
    bgc,
    themeColor,
    bgimg,
    style,
    margin,
    padding
  } = containerConfig;
  const isExpireShow = isExpire(endTime);
  const tip = endTime && isExpireShow ? endTitle ? endTitle : '页面已过期~' : beforeTitle ? beforeTitle : '活动还未开始，敬请期待~';
  const display = getDisplayBlock(startTime, endTime);
  const currentStyle = {
    background: bgc,
    color: themeColor,
    minHeight: getHeight(),
    backgroundImage: `url(${bgimg})`,
    backgroundRepeat: 'repeat',
    margin,
    padding
  };
  const useStyle = Object.assign(currentStyle, style);
  return display === 'block' ? <div className="scroll-y" style={useStyle}>{children}</div> : <div style={{
    minHeight: getHeight(),
    display: 'flex',
    alignItems: 'center'
  }}>
        <div style={{
      textAlign: 'center',
      transform: 'translateY(-1rem)',
      width: '100%'
    }}>
            <div style={{
        width: '6rem',
        margin: '0 auto'
      }}><img style={{
          width: '100%'
        }} alt={'logo'} src={'https://pic.qingting.fm/activity/123/qtlogo.png'} /></div>
            <div style={{
        fontSize: '0.85rem',
        color: '#333',
        width: '100%',
        textAlign: 'center',
        paddingTop: '0.5rem'
      }}>{tip}</div>
        </div>
    </div>;
};

const ContainnerProvider = Provider('containnerProvider', ({
  context,
  children,
  basicConfig,
  ...props
}) => {
  const [shareConfig, setShareConfig] = useState(basicConfig);
  context.shareConfig = shareConfig;
  context.setShareConfig = setShareConfig;
  return <ContainerRender children={children} basicConfig={shareConfig} {...props}></ContainerRender>;
});

const EnvController = ({
  id: id,
  children: children,
  config: config
}) => {
  const [display, setDisplay] = useState(false);
  const {
    version,
    comparison,
    versionEnv,
    env,
    operation,
    versionOperation
  } = config;
  useEffect(() => {
    // == 环境控制，白名单取正，黑名单取反
    const envDisplay = env === 'all' ? operation === 'allow' : operation === 'allow' ? qt.env[env] : !qt.env[env];
    if (!qt.env.inApp || !version) return setDisplay(envDisplay); // == 环境匹配

    const isMatched = qt.env[versionEnv]; // == 未选不限环境且对应环境不匹配则不做版本控制

    if (versionEnv !== 'all' && !isMatched) return setDisplay(envDisplay);
    qt.compareAppVersion(version).then(comparisons => {
      // == 版本匹配白名单则显示，黑名单取反
      const versionDisplay = versionOperation === 'allow' ? comparisons[comparison] : !comparisons[comparison];
      setDisplay(envDisplay && versionDisplay);
    });
  }, []);
  return children ? display ? <div id={id}>{children}</div> : null : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div>;
};

const BaseLayout = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    commonStyle,
    positionStyle,
    spacingStyle
  } = config;
  const {
    background
  } = commonStyle;
  const style = { ...commonStyle,
    ...positionStyle,
    ...spacingStyle
  }; // == 背景设置

  style.background = background.image ? `url(${background.image}) left top / ${background.size} ${background.repeat}` : background.color; // == rem单位处理

  if (style.type === 'rem' || style.type === '%') {
    const {
      type,
      top,
      bottom,
      left,
      right,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      paddingTop,
      paddingBottom,
      paddingLeft,
      paddingRight
    } = style;
    style.top = top ? `${top}${type}` : top;
    style.bottom = bottom ? `${bottom}${type}` : bottom;
    style.left = left ? `${left}${type}` : left;
    style.right = right ? `${right}${type}` : right;
    style.marginTop = marginTop ? `${marginTop}${type}` : marginTop;
    style.marginBottom = marginBottom ? `${marginBottom}${type}` : marginBottom;
    style.marginLeft = marginLeft ? `${marginLeft}${type}` : marginLeft;
    style.marginRight = marginRight ? `${marginRight}${type}` : marginRight;
    style.paddingTop = paddingTop ? `${paddingTop}${type}` : paddingTop;
    style.paddingBottom = paddingBottom ? `${paddingBottom}${type}` : paddingBottom;
    style.paddingLeft = paddingLeft ? `${paddingLeft}${type}` : paddingLeft;
    style.paddingRight = paddingRight ? `${paddingRight}${type}` : paddingRight;
  }

  delete style.type;
  return children ? <div id={id} style={style}>{children}</div> : <div className="text-center mv-3 f14">请添加布局子组件</div>;
};

const BaseLayout__3 = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    style
  } = config;
  return children ? <div id={id} style={style}>{children}</div> : <div className="text-center mv-3 f14">请添加布局子组件</div>;
};

const webApiUrl = process.env.SITE_ENV && process.env.SITE_ENV === 'prd' ? 'https://webapi.qingting.fm' : 'https://webapi.staging.qingting.fm';
const qtLoginEnv = process.env.SITE_ENV && process.env.SITE_ENV === 'prd' ? 'production' : 'staging';
const code = "861248761816342";
const couponImg = "https://sss.qingting.fm/bp/5f4db4d6ad2bf42cc134580b/image/2a64ec17a1142bd3b3403dbfe11065b5.png";
const hasReceiveImg = "https://sss.qingting.fm/bp/5f4db4d6ad2bf42cc134580b/image/240ecd5d47edb8feeb30fc4679ba6c62.png";
const limit = "1";
const couponStyle = {
  absolute: false,
  top: null,
  left: null,
  right: null,
  bottom: null
};

const Coupon = ({
  imgSrc: imgSrc,
  hasReceiveImg: hasReceiveImg,
  style: style,
  useCode: useCode,
  limitNum: limitNum
}) => {
  // let userId = '';
  const [userId, setUserId] = useState__8('');
  const [hasReceived, setHasReceived] = useState__8(false);
  const [deviceId, setDeviceId] = useState__8('');
  const [token, setToken] = useState__8(''); // useEffect(() => {
  //   qt.getUserId().then(id => userId = id)
  // }, [])

  const setuserInfo = () => {
    qt.getUserId().then(id => setUserId(id));
    qt.getDevice().then(res => {
      setDeviceId(res.deviceId);
      return qt.getAccessToken();
    }).then(token => setToken(token)); // if (qt.env.inApp) {
    //   qt.getUserId().then(id => setUserId(id));
    //   qt.getDevice().then(res => {
    //     setDeviceId(res.deviceId)
    //     return qt.getAccessToken()
    //   }).then(token => setToken(token))
    // } else {
    //   setUserId('9ae0b0d09290424db9ec77658154efec');
    //   setDeviceId('91823705005');
    // }
  };

  useEffect__8(() => {
    setuserInfo();
    window.addEventListener('JSSDK_LOGIN', e => {
      setuserInfo();
    });
  }, []);

  const receive = () => {
    if (userId) {
      let userMsg = JSON.parse(localStorage.getItem(userId) || "{}");

      if (userMsg.exchangeCount !== undefined && userMsg.exchangeCount > limitNum) {
        setHasReceived(true);
        return;
      } // {
      //   user_id: userId,
      //   use_code: useCode,
      //   // device_id: deviceId,
      //   access_token: token
      // }


      axios.get(`${webApiUrl}/daily-checkin/accessibility/`, {
        params: {
          user_id: userId,
          use_code: useCode,
          // device_id: deviceId,
          access_token: token
        },
        withCredentials: true
      }).then(data => {
        if (data && data.data && data.data.errorno === 0) {
          userMsg.exchangeCount = userMsg.exchangeCount + 1 || 0;
          localStorage.setItem(userId, JSON.stringify(userMsg));
          Toast.info({
            content: '领取成功',
            duration: 2000
          });
        } else {
          console.log(data);
          console.log(data.data);

          if (data && data.data && data.data.errorno === 43005) {
            setHasReceived(true);
          }

          Toast.info({
            content: data && data.data && data.data.errormsg || '领取失败',
            duration: 2000
          });
        }
      });
    } else {
      qt.login({
        env: qtLoginEnv
      });
    }
  };

  return <>

  <div style={{
      width: '70%',
      color: '#000000',
      background: '#FFE956',
      height: '1rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: 'auto',
      marginTop: '0px',
      zIndex: '10',
      borderRadius: '0.5rem',
      fontSize: '0.39rem',
      fontWeight: '500'
    }} onClick={() => receive()} // aria-label={'点击领取'}
    >
   {hasReceived ? '已领取' : '领取礼品'}
    </div>
  </>; // return imgSrc ? 
  // <img src={hasReceived ? hasReceiveImg : imgSrc} style={style} onClick={() => receive()} alt='' /> :
  //   <div>请上传图片</div>
};

export default (({}) => {
  const basicConfig = {
    title: "蜻蜓FM",
    shareTitle: "蜻蜓FM",
    shareImg: "https://sss.staging.qingting.fm/qt-builder-manage/upload_2bb66b65e93998005bb3751e72cb7f3b.png",
    shareSubTitle: "",
    shareLink: "",
    isHiddenAppShare: false
  };
  const containerConfig = {
    startTime: null,
    endTime: null,
    bgc: "#ff8168",
    themeColor: "#333",
    style: {},
    endTitle: "页面已过期~",
    beforeTitle: "活动还未开始，敬请期待~",
    bgimg: "",
    padding: "",
    margin: ""
  };
  const envController = {
    env: "inApp",
    operation: "allow",
    version: "",
    comparison: "isEqual",
    versionEnv: "all",
    versionOperation: "allow"
  };
  const baseLayoutConfig = {
    commonStyle: {
      textAlign: "center",
      height: 560,
      overflow: "scroll",
      background: {
        color: "transparent",
        image: "https://sss.qingting.fm/bp/5faf76df41195f3cc842510a/image/de7c7203e09706f109926ec7c2a22b14.png",
        repeat: "no-repeat",
        size: "100% auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: 0,
      bottom: 0,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const baseLayoutConfig__3 = {
    style: {
      "textAlign": "left",
      "backgroundRepeat": "no-repeat",
      "backgroundColor": "#ff3c40",
      "position": "static",
      "width": "100%",
      "height": "1rem",
      "marginLeft": "auto",
      "marginRight": "auto",
      "marginTop": "-0.2rem"
    }
  };
  const subTitleText = "小小礼物 不成敬意";
  const subTitleStyle = {
    "WebkitLineClamp": 2,
    "WebkitBoxOrient": "vertical",
    "paddingLeft": "5px",
    "marginTop": "1.5rem",
    "marginBottom": null,
    "marginLeft": "auto",
    "position": "static",
    "marginRight": "auto",
    "paddingTop": "5px",
    "paddingRight": "5px",
    "paddingBottom": "5px",
    "borderTopWidth": null,
    "borderTopStyle": null,
    "borderTopColor": null,
    "borderRightWidth": null,
    "borderRightStyle": null,
    "borderRightColor": null,
    "borderBottomWidth": null,
    "borderBottomStyle": null,
    "borderBottomColor": null,
    "borderLeftWidth": 3,
    "borderLeftStyle": "solid",
    "borderLeftColor": "#e6534f",
    "overflow": "hidden",
    "display": "-webkit-box",
    "fontSize": "0.7rem",
    "color": "#ffffff",
    "fontWeight": "bolder",
    "lineHeight": 1,
    "textOverflow": "ellipsis",
    "fontFamily": "Microsoft Yahei",
    "textAlign": "center"
  };
  const subTitleText__5 = "感谢您对蜻蜓FM的支持";
  const subTitleStyle__5 = {
    "WebkitLineClamp": 2,
    "WebkitBoxOrient": "vertical",
    "overflow": "hidden",
    "display": "-webkit-box",
    "borderTopWidth": null,
    "borderTopStyle": null,
    "borderTopColor": null,
    "borderRightWidth": null,
    "borderRightStyle": null,
    "borderRightColor": null,
    "borderBottomWidth": null,
    "borderBottomStyle": null,
    "borderBottomColor": null,
    "borderLeftWidth": 3,
    "borderLeftStyle": "solid",
    "borderLeftColor": "#e6534f",
    "paddingLeft": 10,
    "marginTop": "0.5rem",
    "marginBottom": null,
    "marginLeft": "auto",
    "position": "static",
    "marginRight": "auto",
    "fontSize": "0.5rem",
    "color": "#ffffff",
    "fontWeight": "bold",
    "lineHeight": 1,
    "textOverflow": "ellipsis",
    "fontFamily": "Microsoft Yahei"
  };
  const subTitleText__6 = "免费送您【VIP月卡】体验";
  const subTitleStyle__6 = {
    "WebkitLineClamp": 2,
    "WebkitBoxOrient": "vertical",
    "overflow": "hidden",
    "display": "-webkit-box",
    "paddingLeft": 10,
    "marginTop": "0.2rem",
    "marginBottom": null,
    "marginLeft": "auto",
    "position": "static",
    "marginRight": "auto",
    "borderTopWidth": null,
    "borderTopStyle": null,
    "borderTopColor": null,
    "borderRightWidth": null,
    "borderRightStyle": null,
    "borderRightColor": null,
    "borderBottomWidth": null,
    "borderBottomStyle": null,
    "borderBottomColor": null,
    "borderLeftWidth": 3,
    "borderLeftStyle": "solid",
    "borderLeftColor": "#e6534f",
    "fontSize": "0.5rem",
    "color": "#ffffff",
    "fontWeight": "bold",
    "lineHeight": 1,
    "textOverflow": "ellipsis"
  };
  const baseLayoutConfig__7 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "rem"
    },
    positionStyle: {
      position: "relative",
      top: 3.9,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: 0.2,
      marginRight: 0.2,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const style = {
    display: 'block',
    width: '100%',
    position: couponStyle.absolute ? 'absolute' : 'relative'
  };

  if (couponStyle.absolute) {
    Object.assign(style, {
      top: couponStyle.top,
      left: couponStyle.left,
      right: couponStyle.right,
      bottom: couponStyle.bottom
    });
  } else {
    Object.assign(style, {
      marginTop: couponStyle.top,
      marginLeft: couponStyle.left,
      marginRight: couponStyle.right,
      marginBottom: couponStyle.bottom
    });
  }

  const subTitleText__9 = "规则：每部手机限领取一次，多次无效";
  const subTitleStyle__9 = {
    "WebkitLineClamp": 2,
    "WebkitBoxOrient": "vertical",
    "paddingLeft": null,
    "marginTop": null,
    "marginBottom": null,
    "marginLeft": null,
    "position": "fixed",
    "marginRight": null,
    "left": null,
    "right": null,
    "width": "100%",
    "bottom": "1.5rem",
    "fontSize": "0.39rem",
    "color": "#ffffff",
    "fontWeight": "normal",
    "lineHeight": 1,
    "textOverflow": "ellipsis",
    "textShadow": "0px 0px 0px rgba(255,0,0, 0)",
    "borderTopWidth": null,
    "borderTopStyle": null,
    "borderTopColor": null,
    "borderRightWidth": null,
    "borderRightStyle": null,
    "borderRightColor": null,
    "borderBottomWidth": null,
    "borderBottomStyle": null,
    "borderBottomColor": null,
    "borderLeftWidth": null,
    "borderLeftStyle": null,
    "borderLeftColor": "#e6534f",
    "borderRadius": null,
    "overflow": "hidden",
    "display": "-webkit-box"
  };
  return <ContainnerProvider id="f50" nodeId="da3bd721-52db-46cb-a9ba-4150b0e84f50" nodeType="component-container" containerConfig={containerConfig} basicConfig={basicConfig}><EnvController id="c3a" nodeId="08501b15-1579-4a7f-9d5a-66eaebf1ac3a" nodeType="env-controller" config={envController}><BaseLayout id="2cd" nodeId="54668fd0-04ab-4f32-80c9-6b869d5f52cd" nodeType="base-layout" config={baseLayoutConfig}><BaseLayout__3 id="d67" nodeId="4d96667d-3754-45e9-93bf-c14fb676dd67" nodeType="base-layout" config={baseLayoutConfig__3}><div id="cc8" nodeId="21038590-fc66-4e74-afcb-c1b3709e9cc8" nodeType="topic-sub-title" style={subTitleStyle}>{subTitleText}</div></BaseLayout__3><div id="d8c" nodeId="68acae59-c9d0-4c0f-a982-109f160b3d8c" nodeType="topic-sub-title" style={subTitleStyle__5}>{subTitleText__5}</div><div id="d5b" nodeId="40d61672-63bb-43d5-8d4d-d96e2c22ed5b" nodeType="topic-sub-title" style={subTitleStyle__6}>{subTitleText__6}</div><BaseLayout id="a48" nodeId="01dda0ef-9269-4ea7-ad6c-e21e05515a48" nodeType="base-layout" config={baseLayoutConfig__7}><Coupon id="801" nodeId="a037c182-a20d-47de-ad4d-9dffe435e801" nodeType="growth-coupon" imgSrc={couponImg} hasReceiveImg={hasReceiveImg} style={style} useCode={code} limitNum={limit}></Coupon></BaseLayout><div id="f04" nodeId="cdc335d0-1dec-42d3-8c22-e9bee960df04" nodeType="topic-sub-title" style={subTitleStyle__9}>{subTitleText__9}</div></BaseLayout></EnvController></ContainnerProvider>;
});